module.exports = __webpack_public_path__ + "img/4.a4a06199.png";